import { create } from 'zustand'
import api from '@/lib/api'

export interface AppNotification {
  id: number
  type: string
  title: string
  body: string
  is_read: boolean
  created_at: string
}

interface NotificationState {
  notifications: AppNotification[]
  unreadCount: number
  fetch: () => Promise<void>
  markAllRead: () => Promise<void>
}

export const useNotificationStore = create<NotificationState>((set) => ({
  notifications: [],
  unreadCount: 0,

  fetch: async () => {
    try {
      const res = await api.get<AppNotification[]>('/api/notifications/')
      const notifications = res.data
      set({
        notifications,
        unreadCount: notifications.filter((n) => !n.is_read).length,
      })
    } catch {
      // silently ignore — network errors shouldn't break the app
    }
  },

  markAllRead: async () => {
    try {
      await api.post('/api/notifications/read-all/')
      set((state) => ({
        notifications: state.notifications.map((n) => ({ ...n, is_read: true })),
        unreadCount: 0,
      }))
    } catch {
      // ignore
    }
  },
}))
